export const ReactNativeEmailLink = () => {
	return null;
};
